import { useSelector } from 'react-redux'

import RelatedAsset from './RelatedAsset'

const Container = () => {
  const relatedAssets = useSelector(
    state => state.asset.relatedAssets.assetsOrder
  )

  return(
    <ul className='related_products__container d-flex flex-column
      align-items-center align-items-md-start flex-md-row m-0 pl-0 pr-0'
    >
      {relatedAssets.map(key => (
        <RelatedAsset assetKey={key} key={key} />
      ))}
    </ul>
  )
}

export default Container
